import { createAction, props } from '@ngrx/store';
import { StoreMetadata } from '@gelato-api-ui/core/e-commerce/types/e-commerce-store-metadata-types';

export const loadUploadDesignLeftLimits = createAction('[HeaderCreateMenu] Load upload design left menu');
export const uploadMetadataSuccess = createAction(
  '[HeaderCreateMenu] Load metadata success',
  props<{ metadata: StoreMetadata[] }>(),
);

export const updateUploadDesignLeftLimitsMetadata = createAction(
  '[HeaderCreateMenu] Update limits metadata',
  props<{ storeId: string }>(),
);
export const updateUploadDesignLeftLimitsMetadataSuccess = createAction(
  '[HeaderCreateMenu] Update limits metadata success',
  props<{ metadata: StoreMetadata[] }>(),
);
